<template>
  <div class="row">
    <div class="col-12 mb-3">
      <button class="btn btn-primary" @click="$router.push({name: 'edit_story' , params: {id: 'new'}})">
        افزودن
        <i class="fas fa-plus"/>
      </button>
      <hr>
    </div>
    <div class="col-12 mb-3">
      <h4 class="text-right text--orange">
        جستجو داستان
      </h4>
    </div>
    <div class="col-12">
      <form class="text-right">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="title" class="text-right mb-1">عنوان</label>
              <input id="title" v-model="filters.title" type="text" class="fv-sm form-control" placeholder="عنوان">
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="name" class="text-right mb-1">نام</label>
              <input id="name" v-model="filters.name" type="text" class="fv-sm form-control" placeholder="نام">
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="min_age" class="text-right mb-1">حداقل سن</label>
              <input id="min_age" v-model.number="filters.min_age" type="number" class="fv-sm form-control"
                     placeholder="حداقل سن">
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="max_age" class="text-right mb-1">حداکثر سن</label>
              <input id="max_age" v-model.number="filters.max_age" type="number" class="fv-sm form-control"
                     placeholder="حداکثر سن">
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="categories">دسته بندی</label>
              <appCategorySelect id="categories" placeholder="دسته بندی" v-model="filters.category_ids"
                                 :multiple="true"/>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="genders" class="text-right mb-1">جنسیت</label>
              <appGendersSelect id="genders" placeholder="جنسیت" v-model="filters.genders" :multiple="true"/>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="author" class="text-right mb-1">نویسنده</label>
              <appUserSelect :justId="true" id="author" placeholder="نویسنده" type="author"
                             v-model="filters.author_ids"/>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="narrator" class="text-right mb-1">قصه گو</label>
              <appUserSelect :justId="true" id="narrator" placeholder="قصه گو" type="narrator"
                             v-model="filters.narrator_ids"/>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="illustrator" class="text-right mb-1">تصویرگر</label>
              <appUserSelect :justId="true" id="illustrator" placeholder="تصویرگر" type="illustrator"
                             v-model="filters.illustrator_ids"/>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-8 col-lg-12 col-xl-6">
            <appRangeDatePicker fromLabel="از تاریخ ایجاد" toLabel="تا تاریخ ایجاد" v-model="filters.$and"
                                id="createdAt"/>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group text-right" v-on:keyup.enter="beforeSearch">
              <label for="premium">داستان پولی</label>

              <fvSelect class="form-control select text-right fv-size-md" id="premium"
                        :value="filters.premium_required ? !filters.premium_required.$ne : undefined"
                        @input="$event ? filters.premium_required = true : $event === false ? filters.premium_required = {$ne:true} : filters.premium_required = undefined"
                        :options="[{text: 'داستان پولی' , value: true},{text: 'داستان غیر پولی' , value: false}]"
                        placeholder="وضعیت پرداخت"
              >

                <template slot="option" slot-scope="scope">
                  <div
                      class="imageWithName">
                    <div
                        :class="`dropdown-item-text ${scope.option.value? 'text-success' : scope.option.value === false ? 'text-danger' : 'text-warning'}`">
                      <b>{{scope.option.text || "---"}} </b>
                    </div>
                    <div
                        :class="`dropdown-item-text ${scope.option.value? 'text-success' : scope.option.value === false ? 'text-danger' : 'text-warning'}`">
                      <div>
                        <i v-if="scope.option.value === true" class="far fa-check-circle"/>
                        <i v-else-if="scope.option.value  === false" class="far fa-times-circle"/>
                        <i v-else-if="scope.option.value  === null || item.is_verified === undefined"
                           class="fas fa-clock"/>
                      </div>
                    </div>
                  </div>

                </template>
              </fvSelect>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
                <div class="form-group" v-on:keyup.enter="beforeSearch">
                  <label for="sort" class="text-right mb-1">نمایش براساس</label>
                  <fv-select id="sort" class="fv-form-control" v-model="sort"
                             :options="[
                         {text: 'جدیدترین',value:'-_score,-created_at'},
                         {text: 'قدیمی ترین',value:'-_score,updated_at'},
                         {text: 'بیشترین لایک',value:'-_score,-total_likes_count'},
                         {text: 'کمترین لایک',value:'-_score,total_likes_count'},
                         {text: 'بیشترین شنیده شده',value:'-_score,-total_views_count'},
                         {text: 'کمترین شنیده شده',value:'-_score,total_views_count'},
                         {text: 'بیشترین کامنت',value:'-_score,-total_comments_count'},
                         {text: 'کمترین کامنت',value:'-_score,total_comments_count'},
                         ]"/>
                </div>

              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
                <div class="form-group" v-on:keyup.enter="beforeSearch">
                  <label for="perpage" class="text-right mb-1">تعداد نمایش</label>
                  <fvSelect class="fv-form-control"
                            id="perpage"
                            @input="changePerPage"
                            :value="pagination.per_page"
                            :options="$store.state.main.per_page"
                            placeholder="تعداد نمایش"
                  >

                  </fvSelect>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
                <div class="form-group" v-on:keyup.enter="beforeSearch">
                  <label for="enable" class="text-right mb-1">فعال</label>
                  <fv-switch id="enable" class="d-block" placeholder="فعال"
                             v-model="filters.enabled"/>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 text-left d-flex">
            <button type="button" @click="$router.push({})" class="btn btn-danger ml-auto">
              حذف فیلترها
              <i class="fas fa-trash"/>
            </button>
            <button type="button" @click.prevent="downloadExcel" class="btn btn-primary ml-3">
              دانلود اکسل
              <i class="fas fa-download"/>
            </button>
            <button @click.prevent="beforeSearch" class="btn btn-info">
              جستجو
              <i class="fas fa-search"/>
            </button>
          </div>
        </div>
      </form>
      <hr>
    </div>
    <div class="col-12">
      <fvTable class="fv-size-lg" v-if="item.length > 0" :fields="fields" :rows="item">
        <template slot="field-#" , slot-scope="scope">
          <span>{{scope.index + 1 + ( (page - 1) * (pagination.page === 1 ? 0 : pagination.per_page ) )}}</span>
        </template>
        <template slot="field-عنوان" slot-scope="scope">
          {{scope.row.title || '---'}}
        </template>
        <template slot="field-توضیحات" slot-scope="scope">
          <div v-html="scope.row.description || '---'"/>
        </template>
        <template slot="field-دسته بندی" slot-scope="scope">
          <div v-if="scope.row.categories && scope.row.categories.length > 0">
            <span v-for="(val , i) in scope.row.categories" :key="`cat${i}`">
              <router-link class="text-info" :to="{name: 'edit_category' , params: {id: val.id}}">
                {{val.title}}{{scope.row.categories.length > 1 && scope.row.categories.length + 1 !== i ? ',' : ''}}
              </router-link>
            </span>
          </div>
          <div v-else>---</div>
        </template>

        <template slot="field-تاریخ ثبت" slot-scope="scope">
          {{$dateTimeFormat(scope.row.created_at)}}
        </template>
        <template slot="field-actions" slot-scope="scope">
          <button @click="$router.push({name: 'edit_story' , params : {id: scope.row.id} })"
                  class="btn btn-warning btn-sm">
            تغییر
            <i class="far fa-edit"/>
          </button>
        </template>
      </fvTable>

    </div>
    <div class="col-12 text-center mt-5" v-if="Object.keys(item).length && pagination.pages > 1">
      <appPagination :pageCount="pagination.pages" v-model="page" @input="search"/>
    </div>

  </div>
</template>
<script>

	import {mapActions} from "vuex"
	import appUserSelect from "../../components/appUserSelect";
	import appGendersSelect from "../../components/appGendersSelect";
	import appCategorySelect from "../../components/appCategorySelect";
	import appPagination from "../../components/appPagination";
	import appRangeDatePicker from "../../components/appRangeDatePicker";
	import FileSaver from "file-saver";

	export default {
		name: 'stories',
		data() {
			return {
				...mapActions('main', [
					'crud'
				]),
				item: [],
				fields: ['#', 'عنوان', 'توضیحات', 'دسته بندی', 'تاریخ ثبت', 'actions'],
				query: {},
				filters: {},
				sort: '-_score,-created_at',
				page: 1,
				pagination: {per_page: 50}
			}
		},
		components: {
			appPagination,
			appUserSelect,
			appGendersSelect,
			appCategorySelect,
			appRangeDatePicker
		},
		methods: {
			parseQueries() {
				const {query} = this.$route
				const {page, filters, sort, per_page} = query;
				const filtersObj = filters ? JSON.parse(filters) : {enabled: true}


				this.sort = sort || '-_score,-created_at'
				this.filters = filtersObj
				this.query = query
				this.page = page ? parseInt(page) : 1
				this.pagination.per_page = per_page
			},
			async getData() {
				this.parseQueries()
				this.$store.commit('main/SET', {key: 'loading', value: true})
				try {
					const apiFilters = await this.$generateFilter(this.filters)
					const item = await this.crud({
						action: 'get',
						section: 'stories',
						query: `${this.$queryGenerator(apiFilters, this.sort)}${this.page >= 1 ? `&page=${this.page}` : ''}`,
						perPage: this.pagination.per_page
					})
						const result = item.data.items
						this.item = result
						this.pagination = item.data.pagination
				} catch (e) {
					// console.log(e)
				} finally {
					this.$store.commit('main/SET', {key: 'loading', value: false})
				}
			},
			async downloadExcel() {
				this.$store.commit('main/SET', {key: 'loading', value: true})
				try {
					const filters = await this.$generateFilter(this.filters)

					const data = {filters, page: this.page, limit: this.pagination.per_page}
					const users = await this.crud({
						action: 'post',
						section: 'export/stories',
						data,
						perPage: this.pagination.per_page,
						requestOptions: {responseType: 'blob'},
					})
					console.log(users.data)
					if (users.data) {
						FileSaver.saveAs(users.data, 'stories.csv');
					}
				} catch (e) {
					console.log(e)
				} finally {
					this.$store.commit('main/SET', {key: 'loading', value: false})
				}
			},
			async search() {
				this.filters = await this.$validateFilter(this.filters)
				await this.$router.push({
					query: {
						filters: Object.keys(this.filters).length > 0 ? JSON.stringify(this.filters) : undefined,
						sort: this.sort || undefined,
						page: this.page,
						per_page: this.pagination.per_page
					}
				})
			},
			beforeSearch() {
				this.page = 1
				this.search()
			},
			changePerPage(value) {
				this.pagination.per_page = value
				this.beforeSearch()
			},
		},

		async created() {
			await this.getData()
		},
		watch: {
			'$route.query'() {
				this.getData();
			}
		},

		// beforeUpdate() {
		// }
	};
</script>
<style>
</style>
